import '.d{display:flex;}.ssr-plugin'
import '.dz{flex-shrink:1;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.e0{max-height:calc(100vh - 10rem);}.ssr-plugin'
import { styled } from 'inlines'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { ReactNode } from 'react'
import { IconButton } from '@app/components/core/button/IconButton'
import {
  faArrowRight,
  faArrowLeft,
  faImages,
} from '@fortawesome/pro-regular-svg-icons'
import { Button } from '@app/components/core/button/Button'
import { Image } from '@app/components/core/image/Image'
import useMediaQuery from '@app/util/useMediaQuery'

export type ImageDisplayProps = {
  displayedImage: string
  overviewButtonLabel: string
  header: ReactNode
  canGoBack: boolean
  canGoForwad: boolean
  goBack: () => void
  goForward: () => void
  goToOverview?: () => void
}

export const ImageDisplay = ({
  displayedImage,
  overviewButtonLabel,
  header,
  canGoBack,
  canGoForwad,
  goBack,
  goForward,
  goToOverview,
}: ImageDisplayProps) => {
  const isMobile = useMediaQuery()
  return (
    <Row
      style={{
        alignItems: 'center',
        width: '100%',
        padding: '2rem',
        gap: '1rem',
        maxHeight: '100vh',
      }}
    >
      {canGoBack && <IconButton icon={faArrowLeft} onClick={goBack} />}
      <Column
        style={{
          alignItems: 'center',
          minWidth: 0,
          width: '100%',
        }}
      >
        <Column alignItems="stretch">
          {header}
          <div className="d dz ab r l e0"
          >
            <Image
              src={displayedImage}
              resizeWidth={isMobile ? 800 : 1920}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
                display: 'block',
                borderRadius: '1.25rem',
              }}
            />
          </div>
          {goToOverview && (
            <Button
              variant="secondary"
              label={overviewButtonLabel}
              icon={faImages}
              iconPosition="left"
              onClick={goToOverview}
              style={{ alignSelf: 'end' }}
            />
          )}
        </Column>
      </Column>
      {canGoForwad && <IconButton icon={faArrowRight} onClick={goForward} />}
    </Row>
  )
}
